module.exports = __webpack_public_path__ + "img/setting.793da202.svg";